import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 16,
    marginBottom: 24
  },
  paper: {
    padding: '32px 20px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 20
  },
  formItem: {}
}))

export default useStyles
